import React, {
  useEffect,
  useState,
} from "react";

import {
  FaArrowLeft,
  FaEye,
  FaEyeSlash,
  FaDownload,
  FaUpload,
  FaExchangeAlt,
  FaCoins,
  FaSlidersH,
  FaWallet,
  FaChevronDown,
  FaChevronUp,
  FaTrophy,
} from "react-icons/fa";

import { useNavigate } from "react-router-dom";

import {
  collection,
  query,
  where,
  onSnapshot,
} from "firebase/firestore";

import { db } from "../firebase";

import DepositRecord from "./DepositRecord";
import WithdrawRecord from "./WithdrawRecord";

import "./Assets.css";


/* =========================================================
   FIRESTORE BALANCE FIELDS
========================================================= */

const fieldMap = {
  TZS: "tshBalance",
  USDT: "usdtBalance",
  KES: "KESBalance",
  UGX: "UGXBalance",
  RWF: "RWFBalance",
  BIF: "BIFBalance",
  ZMW: "ZMWBalance",
  MWK: "MWKBalance",
  MZN: "MZNBalance",
  USD: "USDBalance",
  SSP: "SSPBalance",
  BWP: "BWPBalance",
  MGA: "MGABalance",
};


const translationKeys = ["estimatedBalance", "deposit", "withdraw", "records", "earn", "portfolio", "funding", "trading", "earning", "withdrawRecord", "depositRecord", "crypto", "forex", "value", "nameAmount", "loadingEarnings", "userNotFound", "noWinningRecords", "winningResults", "profit", "result", "type", "match", "score", "date", "time", "stake", "totalWin", "odds", "betId", "hideBalance", "showBalance", "portfolioSettings", "correctScore", "antscore", "win", "yourForexAssets", "pleaseLogin", "yourWinningResults", "todayPnl"];

const languageLabels = {
  en: ["Estimated Balance", "Deposit", "Withdraw", "Records", "Earn", "Portfolio", "Funding", "Trading", "Earning", "Withdraw Record", "Deposit Record", "Crypto", "Forex", "Value", "Name / Amount", "Loading earnings...", "User Not Found", "No Winning Records", "Winning results", "Profit", "Result", "Type", "Match", "Score", "Date", "Time", "Stake", "Total Win", "Odds", "Bet ID", "Hide balance", "Show balance", "Portfolio settings", "Correct Score", "Antscore", "Win", "Your forex assets will appear here.", "Please log in again to view your earnings.", "Your winning results will appear here.", "Today's PnL"],
  sw: ["Salio la Makadirio", "Weka Pesa", "Toa Pesa", "Rekodi", "Pata Mapato", "Jalada la Mali", "Ufadhili", "Biashara", "Mapato", "Rekodi za Kutoa", "Rekodi za Kuweka", "Sarafu za Kidijitali", "Forex", "Thamani", "Jina / Kiasi", "Inapakia mapato...", "Mtumiaji Hakupatikana", "Hakuna Rekodi za Ushindi", "Matokeo ya ushindi", "Faida", "Matokeo", "Aina", "Mechi", "Alama", "Tarehe", "Muda", "Dau", "Jumla ya Ushindi", "Odds", "Kitambulisho cha Dau", "Ficha salio", "Onyesha salio", "Mipangilio ya jalada", "Correct Score", "Antscore", "Ushindi", "Mali zako za forex zitaonekana hapa.", "Tafadhali ingia tena ili kuona mapato yako.", "Matokeo yako ya ushindi yataonekana hapa.", "PnL ya Leo"],
  fr: ["Solde estimé", "Dépôt", "Retrait", "Historique", "Gagner", "Portefeuille", "Financement", "Trading", "Gains", "Historique des retraits", "Historique des dépôts", "Crypto", "Forex", "Valeur", "Nom / Montant", "Chargement des gains...", "Utilisateur introuvable", "Aucun gain enregistré", "Résultats gagnants", "Profit", "Résultat", "Type", "Match", "Score", "Date", "Heure", "Mise", "Gain total", "Cotes", "ID du pari", "Masquer le solde", "Afficher le solde", "Paramètres du portefeuille", "Score exact", "Antscore", "Gagné", "Vos actifs forex apparaîtront ici.", "Veuillez vous reconnecter pour voir vos gains.", "Vos résultats gagnants apparaîtront ici.", "PnL du jour"],
  pt: ["Saldo estimado", "Depósito", "Saque", "Registros", "Ganhar", "Portfólio", "Financiamento", "Negociação", "Ganhos", "Registro de saques", "Registro de depósitos", "Cripto", "Forex", "Valor", "Nome / Quantia", "Carregando ganhos...", "Usuário não encontrado", "Nenhum registro de vitória", "Resultados vencedores", "Lucro", "Resultado", "Tipo", "Partida", "Placar", "Data", "Hora", "Aposta", "Vitória total", "Odds", "ID da aposta", "Ocultar saldo", "Mostrar saldo", "Configurações do portfólio", "Placar correto", "Antscore", "Vitória", "Seus ativos forex aparecerão aqui.", "Faça login novamente para ver seus ganhos.", "Seus resultados vencedores aparecerão aqui.", "PnL de hoje"],
  es: ["Saldo estimado", "Depósito", "Retirar", "Registros", "Ganar", "Portafolio", "Fondos", "Trading", "Ganancias", "Registro de retiros", "Registro de depósitos", "Cripto", "Forex", "Valor", "Nombre / Cantidad", "Cargando ganancias...", "Usuario no encontrado", "Sin registros ganadores", "Resultados ganadores", "Beneficio", "Resultado", "Tipo", "Partido", "Marcador", "Fecha", "Hora", "Apuesta", "Ganancia total", "Cuotas", "ID de apuesta", "Ocultar saldo", "Mostrar saldo", "Configuración del portafolio", "Marcador correcto", "Antscore", "Victoria", "Tus activos de forex aparecerán aquí.", "Inicia sesión de nuevo para ver tus ganancias.", "Tus resultados ganadores aparecerán aquí.", "PnL de hoy"],
  ar: ["الرصيد التقديري", "إيداع", "سحب", "السجلات", "اكسب", "المحفظة الاستثمارية", "التمويل", "التداول", "الأرباح", "سجل السحب", "سجل الإيداع", "العملات الرقمية", "فوركس", "القيمة", "الاسم / المبلغ", "جارٍ تحميل الأرباح...", "المستخدم غير موجود", "لا توجد سجلات فوز", "النتائج الفائزة", "الربح", "النتيجة", "النوع", "المباراة", "النتيجة", "التاريخ", "الوقت", "الرهان", "إجمالي الفوز", "الاحتمالات", "معرّف الرهان", "إخفاء الرصيد", "إظهار الرصيد", "إعدادات المحفظة", "النتيجة الصحيحة", "Antscore", "فوز", "ستظهر أصول الفوركس هنا.", "يرجى تسجيل الدخول مرة أخرى لعرض أرباحك.", "ستظهر نتائج الفوز هنا.", "صافي ربح/خسارة اليوم"],
  zh: ["预估余额", "充值", "提现", "记录", "赚取", "投资组合", "资金", "交易", "收益", "提现记录", "充值记录", "加密货币", "外汇", "价值", "名称 / 金额", "正在加载收益...", "未找到用户", "没有获胜记录", "获胜结果", "利润", "结果", "类型", "比赛", "比分", "日期", "时间", "投注", "总获胜金额", "赔率", "投注编号", "隐藏余额", "显示余额", "投资组合设置", "正确比分", "Antscore", "获胜", "您的外汇资产将在此显示。", "请重新登录以查看收益。", "您的获胜结果将在此显示。", "今日盈亏"],
  hi: ["अनुमानित बैलेंस", "जमा करें", "निकासी", "रिकॉर्ड", "कमाएँ", "पोर्टफोलियो", "फंडिंग", "ट्रेडिंग", "कमाई", "निकासी रिकॉर्ड", "जमा रिकॉर्ड", "क्रिप्टो", "फॉरेक्स", "मूल्य", "नाम / राशि", "कमाई लोड हो रही है...", "उपयोगकर्ता नहीं मिला", "कोई जीत रिकॉर्ड नहीं", "जीत के परिणाम", "लाभ", "परिणाम", "प्रकार", "मैच", "स्कोर", "तारीख", "समय", "दांव", "कुल जीत", "ऑड्स", "बेट आईडी", "बैलेंस छिपाएँ", "बैलेंस दिखाएँ", "पोर्टफोलियो सेटिंग्स", "सही स्कोर", "Antscore", "जीत", "आपकी फॉरेक्स संपत्तियाँ यहाँ दिखाई देंगी।", "कमाई देखने के लिए कृपया फिर से लॉग इन करें।", "आपके जीत के परिणाम यहाँ दिखाई देंगे।", "आज का PnL"],
  bn: ["আনুমানিক ব্যালেন্স", "জমা", "উত্তোলন", "রেকর্ড", "আয় করুন", "পোর্টফোলিও", "ফান্ডিং", "ট্রেডিং", "আয়", "উত্তোলনের রেকর্ড", "জমার রেকর্ড", "ক্রিপ্টো", "ফরেক্স", "মূল্য", "নাম / পরিমাণ", "আয় লোড হচ্ছে...", "ব্যবহারকারী পাওয়া যায়নি", "কোনো জয়ের রেকর্ড নেই", "জয়ের ফলাফল", "লাভ", "ফলাফল", "ধরন", "ম্যাচ", "স্কোর", "তারিখ", "সময়", "বাজি", "মোট জয়", "অডস", "বেট আইডি", "ব্যালেন্স লুকান", "ব্যালেন্স দেখান", "পোর্টফোলিও সেটিংস", "সঠিক স্কোর", "Antscore", "জয়", "আপনার ফরেক্স সম্পদ এখানে দেখা যাবে।", "আয় দেখতে আবার লগইন করুন।", "আপনার জয়ের ফলাফল এখানে দেখা যাবে।", "আজকের PnL"],
  ru: ["Оценочный баланс", "Пополнить", "Вывести", "Записи", "Заработок", "Портфель", "Пополнение", "Торговля", "Доход", "Записи о выводах", "Записи о пополнениях", "Криптовалюта", "Форекс", "Стоимость", "Название / Сумма", "Загрузка доходов...", "Пользователь не найден", "Нет записей о победах", "Результаты побед", "Прибыль", "Результат", "Тип", "Матч", "Счёт", "Дата", "Время", "Ставка", "Общий выигрыш", "Коэффициенты", "ID ставки", "Скрыть баланс", "Показать баланс", "Настройки портфеля", "Точный счёт", "Antscore", "Победа", "Ваши активы Forex появятся здесь.", "Войдите снова, чтобы увидеть доходы.", "Результаты побед появятся здесь.", "PnL за сегодня"],
  de: ["Geschätzter Kontostand", "Einzahlen", "Abheben", "Einträge", "Verdienen", "Portfolio", "Finanzierung", "Handel", "Erträge", "Auszahlungsprotokoll", "Einzahlungsprotokoll", "Krypto", "Forex", "Wert", "Name / Betrag", "Erträge werden geladen...", "Benutzer nicht gefunden", "Keine Gewinnaufzeichnungen", "Gewinnergebnisse", "Gewinn", "Ergebnis", "Typ", "Spiel", "Spielstand", "Datum", "Uhrzeit", "Einsatz", "Gesamtgewinn", "Quoten", "Wett-ID", "Kontostand verbergen", "Kontostand anzeigen", "Portfolio-Einstellungen", "Korrektes Ergebnis", "Antscore", "Gewonnen", "Ihre Forex-Assets erscheinen hier.", "Bitte melden Sie sich erneut an, um Ihre Erträge zu sehen.", "Ihre Gewinnergebnisse erscheinen hier.", "Heutiger PnL"],
  it: ["Saldo stimato", "Deposita", "Preleva", "Registri", "Guadagna", "Portafoglio", "Finanziamento", "Trading", "Guadagni", "Registro prelievi", "Registro depositi", "Cripto", "Forex", "Valore", "Nome / Importo", "Caricamento guadagni...", "Utente non trovato", "Nessuna vincita registrata", "Risultati vincenti", "Profitto", "Risultato", "Tipo", "Partita", "Punteggio", "Data", "Ora", "Puntata", "Vincita totale", "Quote", "ID scommessa", "Nascondi saldo", "Mostra saldo", "Impostazioni portafoglio", "Risultato esatto", "Antscore", "Vinto", "I tuoi asset forex appariranno qui.", "Accedi di nuovo per visualizzare i guadagni.", "I risultati vincenti appariranno qui.", "PnL di oggi"],
  nl: ["Geschat saldo", "Storten", "Opnemen", "Records", "Verdienen", "Portfolio", "Financiering", "Handelen", "Verdiensten", "Opnameoverzicht", "Stortingsoverzicht", "Crypto", "Forex", "Waarde", "Naam / Bedrag", "Verdiensten laden...", "Gebruiker niet gevonden", "Geen winstrecords", "Winnende resultaten", "Winst", "Resultaat", "Type", "Wedstrijd", "Score", "Datum", "Tijd", "Inzet", "Totale winst", "Odds", "Wed-ID", "Saldo verbergen", "Saldo tonen", "Portfolio-instellingen", "Correcte score", "Antscore", "Gewonnen", "Je forex-activa verschijnen hier.", "Log opnieuw in om je verdiensten te bekijken.", "Je winnende resultaten verschijnen hier.", "PnL vandaag"],
  tr: ["Tahmini Bakiye", "Yatır", "Çek", "Kayıtlar", "Kazan", "Portföy", "Fonlama", "Alım Satım", "Kazanç", "Çekim Kaydı", "Yatırma Kaydı", "Kripto", "Forex", "Değer", "Ad / Tutar", "Kazançlar yükleniyor...", "Kullanıcı bulunamadı", "Kazanç kaydı yok", "Kazanan sonuçlar", "Kâr", "Sonuç", "Tür", "Maç", "Skor", "Tarih", "Saat", "Bahis", "Toplam Kazanç", "Oranlar", "Bahis Kimliği", "Bakiyeyi gizle", "Bakiyeyi göster", "Portföy ayarları", "Doğru Skor", "Antscore", "Kazandı", "Forex varlıklarınız burada görünecek.", "Kazançlarınızı görmek için tekrar giriş yapın.", "Kazanan sonuçlarınız burada görünecek.", "Bugünkü PnL"],
  ja: ["推定残高", "入金", "出金", "記録", "稼ぐ", "ポートフォリオ", "資金", "取引", "収益", "出金記録", "入金記録", "暗号資産", "外国為替", "価値", "名前 / 金額", "収益を読み込み中...", "ユーザーが見つかりません", "勝利記録はありません", "勝利結果", "利益", "結果", "種類", "試合", "スコア", "日付", "時刻", "賭け金", "総勝利額", "オッズ", "ベットID", "残高を隠す", "残高を表示", "ポートフォリオ設定", "正確なスコア", "Antscore", "勝利", "Forex資産はここに表示されます。", "収益を表示するには再ログインしてください。", "勝利結果がここに表示されます。", "本日のPnL"],
  ko: ["예상 잔액", "입금", "출금", "기록", "수익 얻기", "포트폴리오", "자금", "거래", "수익", "출금 기록", "입금 기록", "암호화폐", "외환", "가치", "이름 / 금액", "수익 로딩 중...", "사용자를 찾을 수 없음", "승리 기록 없음", "승리 결과", "수익", "결과", "유형", "경기", "점수", "날짜", "시간", "베팅 금액", "총 승리 금액", "배당률", "베팅 ID", "잔액 숨기기", "잔액 표시", "포트폴리오 설정", "정확한 점수", "Antscore", "승리", "외환 자산이 여기에 표시됩니다.", "수익을 보려면 다시 로그인하세요.", "승리 결과가 여기에 표시됩니다.", "오늘의 PnL"],
  vi: ["Số dư ước tính", "Nạp tiền", "Rút tiền", "Bản ghi", "Kiếm tiền", "Danh mục đầu tư", "Nạp vốn", "Giao dịch", "Thu nhập", "Lịch sử rút tiền", "Lịch sử nạp tiền", "Tiền mã hóa", "Forex", "Giá trị", "Tên / Số tiền", "Đang tải thu nhập...", "Không tìm thấy người dùng", "Không có bản ghi thắng", "Kết quả thắng", "Lợi nhuận", "Kết quả", "Loại", "Trận đấu", "Tỷ số", "Ngày", "Giờ", "Tiền cược", "Tổng tiền thắng", "Tỷ lệ cược", "ID cược", "Ẩn số dư", "Hiện số dư", "Cài đặt danh mục", "Tỷ số chính xác", "Antscore", "Thắng", "Tài sản forex của bạn sẽ xuất hiện ở đây.", "Vui lòng đăng nhập lại để xem thu nhập.", "Kết quả thắng sẽ xuất hiện ở đây.", "PnL hôm nay"],
  th: ["ยอดเงินโดยประมาณ", "ฝากเงิน", "ถอนเงิน", "รายการ", "รับรายได้", "พอร์ตโฟลิโอ", "เติมเงิน", "การซื้อขาย", "รายได้", "ประวัติการถอน", "ประวัติการฝาก", "คริปโต", "Forex", "มูลค่า", "ชื่อ / จำนวน", "กำลังโหลดรายได้...", "ไม่พบผู้ใช้", "ไม่มีบันทึกการชนะ", "ผลการแข่งขันที่ชนะ", "กำไร", "ผลลัพธ์", "ประเภท", "การแข่งขัน", "คะแนน", "วันที่", "เวลา", "เดิมพัน", "ยอดชนะทั้งหมด", "อัตราต่อรอง", "รหัสเดิมพัน", "ซ่อนยอดเงิน", "แสดงยอดเงิน", "การตั้งค่าพอร์ต", "สกอร์ถูกต้อง", "Antscore", "ชนะ", "สินทรัพย์ Forex ของคุณจะแสดงที่นี่", "โปรดเข้าสู่ระบบอีกครั้งเพื่อดูรายได้", "ผลการชนะของคุณจะแสดงที่นี่", "PnL วันนี้"],
  id: ["Saldo Perkiraan", "Deposit", "Penarikan", "Catatan", "Hasilkan", "Portofolio", "Pendanaan", "Trading", "Penghasilan", "Catatan Penarikan", "Catatan Deposit", "Kripto", "Forex", "Nilai", "Nama / Jumlah", "Memuat penghasilan...", "Pengguna Tidak Ditemukan", "Tidak Ada Catatan Kemenangan", "Hasil kemenangan", "Laba", "Hasil", "Jenis", "Pertandingan", "Skor", "Tanggal", "Waktu", "Taruhan", "Total Kemenangan", "Odds", "ID Taruhan", "Sembunyikan saldo", "Tampilkan saldo", "Pengaturan portofolio", "Skor Tepat", "Antscore", "Menang", "Aset forex Anda akan muncul di sini.", "Silakan masuk kembali untuk melihat penghasilan.", "Hasil kemenangan Anda akan muncul di sini.", "PnL Hari Ini"],
  ms: ["Baki Anggaran", "Deposit", "Pengeluaran", "Rekod", "Pendapatan", "Portfolio", "Pembiayaan", "Dagangan", "Pendapatan", "Rekod Pengeluaran", "Rekod Deposit", "Kripto", "Forex", "Nilai", "Nama / Jumlah", "Memuatkan pendapatan...", "Pengguna Tidak Ditemui", "Tiada Rekod Kemenangan", "Keputusan kemenangan", "Untung", "Keputusan", "Jenis", "Perlawanan", "Skor", "Tarikh", "Masa", "Pertaruhan", "Jumlah Kemenangan", "Odds", "ID Pertaruhan", "Sembunyikan baki", "Tunjukkan baki", "Tetapan portfolio", "Skor Tepat", "Antscore", "Menang", "Aset forex anda akan dipaparkan di sini.", "Sila log masuk semula untuk melihat pendapatan.", "Keputusan kemenangan anda akan dipaparkan di sini.", "PnL Hari Ini"],
  ur: ["تخمینی بیلنس", "جمع کروائیں", "رقم نکالیں", "ریکارڈز", "کمائیں", "پورٹ فولیو", "فنڈنگ", "ٹریڈنگ", "آمدنی", "نکالنے کا ریکارڈ", "جمع کرنے کا ریکارڈ", "کرپٹو", "فاریکس", "قیمت", "نام / رقم", "آمدنی لوڈ ہو رہی ہے...", "صارف نہیں ملا", "جیت کا کوئی ریکارڈ نہیں", "جیت کے نتائج", "منافع", "نتیجہ", "قسم", "میچ", "اسکور", "تاریخ", "وقت", "شرط", "کل جیت", "اوڈز", "بیٹ آئی ڈی", "بیلنس چھپائیں", "بیلنس دکھائیں", "پورٹ فولیو کی ترتیبات", "درست اسکور", "Antscore", "جیت", "آپ کے فاریکس اثاثے یہاں دکھائی دیں گے۔", "آمدنی دیکھنے کے لیے دوبارہ لاگ ان کریں۔", "آپ کے جیت کے نتائج یہاں دکھائی دیں گے۔", "آج کا PnL"],
  fa: ["موجودی تخمینی", "واریز", "برداشت", "سوابق", "کسب درآمد", "سبد دارایی", "تأمین مالی", "معامله", "درآمد", "سوابق برداشت", "سوابق واریز", "رمزارز", "فارکس", "ارزش", "نام / مبلغ", "در حال بارگذاری درآمد...", "کاربر پیدا نشد", "رکورد بردی وجود ندارد", "نتایج برد", "سود", "نتیجه", "نوع", "مسابقه", "امتیاز", "تاریخ", "زمان", "شرط", "کل برد", "ضرایب", "شناسه شرط", "پنهان کردن موجودی", "نمایش موجودی", "تنظیمات سبد", "نتیجه دقیق", "Antscore", "برد", "دارایی‌های فارکس شما اینجا نمایش داده می‌شوند.", "برای مشاهده درآمد دوباره وارد شوید.", "نتایج برد شما اینجا نمایش داده می‌شوند.", "PnL امروز"],
  ha: ["Ma'aunin Kuɗi", "Saka Kuɗi", "Cire Kuɗi", "Rikodi", "Sami Kuɗi", "Jerin Kadarori", "Tallafin Kuɗi", "Ciniki", "Kuɗin Shiga", "Rikodin Cire Kuɗi", "Rikodin Saka Kuɗi", "Crypto", "Forex", "Daraja", "Suna / Adadi", "Ana loda kuɗin shiga...", "Ba a Samu Mai Amfani ba", "Babu Rikodin Nasara", "Sakamakon nasara", "Riba", "Sakamako", "Nau'i", "Wasa", "Maki", "Kwanan wata", "Lokaci", "Kuɗin fare", "Jimillar Nasara", "Odds", "ID ɗin Fare", "Ɓoye ma'auni", "Nuna ma'auni", "Saitunan portfolio", "Correct Score", "Antscore", "Nasara", "Kadarorin forex ɗinka za su bayyana a nan.", "Da fatan za ka sake shiga don ganin kuɗin shigarka.", "Sakamakon nasararka zai bayyana a nan.", "PnL na yau"],
  yo: ["Ìwọ̀n Owó", "Fi Owó Sílẹ̀", "Yọ Owó", "Àkọsílẹ̀", "Gba Èrè", "Portfolio", "Ìpèsè Owó", "Ìṣòwò", "Èrè", "Àkọsílẹ̀ Yíyọ Owó", "Àkọsílẹ̀ Fífi Owó Sílẹ̀", "Crypto", "Forex", "Iye", "Orúkọ / Iye Owó", "Ń kó èrè wá...", "A kò rí Olùlò", "Kò sí àkọsílẹ̀ ìṣẹ́gun", "Àwọn àbájáde ìṣẹ́gun", "Èrè", "Àbájáde", "Irú", "Ìdíje", "Àmì-ẹ̀yẹ", "Ọjọ́", "Àkókò", "Owó tẹtẹ", "Ìṣẹ́gun lápapọ̀", "Odds", "ID tẹtẹ", "Fi ìwọ̀n owó pamọ́", "Fi ìwọ̀n owó hàn", "Ètò portfolio", "Correct Score", "Antscore", "Ìṣẹ́gun", "Àwọn ohun-ìní forex rẹ yóò hàn níbí.", "Jọ̀wọ́ tún wọlé láti rí èrè rẹ.", "Àwọn àbájáde ìṣẹ́gun rẹ yóò hàn níbí.", "PnL òní"],
  zu: ["Ibhalansi Elinganisiwe", "Faka Imali", "Khipha Imali", "Amarekhodi", "Zuza", "Iphothifoliyo", "Uxhaso", "Ukuhweba", "Imali engenayo", "Irekhodi Lokukhipha", "Irekhodi Lokufaka", "I-Crypto", "Forex", "Inani", "Igama / Inani", "Ilayisha imali engenayo...", "Umsebenzisi Akatholakali", "Awekho Amarekhodi Okunqoba", "Imiphumela yokunqoba", "Inzuzo", "Umphumela", "Uhlobo", "Umdlalo", "Amaphuzu", "Usuku", "Isikhathi", "Ukubheja", "Ingqikithi Yokunqoba", "Ama-odds", "I-ID Yokubheja", "Fihla ibhalansi", "Bonisa ibhalansi", "Izilungiselelo zephothifoliyo", "Correct Score", "Antscore", "Win", "Izimpahla zakho ze-forex zizovela lapha.", "Sicela ungene futhi ukuze ubone imali engenayo.", "Imiphumela yakho yokunqoba izovela lapha.", "I-PnL yanamuhla"],
  am: ["የተገመተ ቀሪ ሂሳብ", "ገንዘብ አስገባ", "ገንዘብ አውጣ", "መዝገቦች", "አግኝ", "ፖርትፎሊዮ", "የገንዘብ ማስገቢያ", "ንግድ", "ገቢ", "የማውጣት መዝገብ", "የማስገባት መዝገብ", "ክሪፕቶ", "Forex", "ዋጋ", "ስም / መጠን", "ገቢ በመጫን ላይ...", "ተጠቃሚ አልተገኘም", "የድል መዝገብ የለም", "የድል ውጤቶች", "ትርፍ", "ውጤት", "ዓይነት", "ጨዋታ", "ውጤት", "ቀን", "ሰዓት", "ውርርድ", "ጠቅላላ ድል", "Odds", "የውርርድ መለያ", "ቀሪ ሂሳብ ደብቅ", "ቀሪ ሂሳብ አሳይ", "የፖርትፎሊዮ ቅንብሮች", "Correct Score", "Antscore", "ድል", "የForex ንብረቶችዎ እዚህ ይታያሉ።", "ገቢዎን ለማየት እንደገና ይግቡ።", "የድል ውጤቶችዎ እዚህ ይታያሉ።", "የዛሬ PnL"],
  so: ["Hadhaaga La Qiyaasay", "Dhig Lacag", "La Bax Lacag", "Diiwaanno", "Kasbo", "Portfolio", "Maalgelin", "Ganacsi", "Dakhli", "Diiwaanka La-baxa", "Diiwaanka Dhigashada", "Crypto", "Forex", "Qiime", "Magac / Qaddar", "Dakhliga waa la rarayaa...", "Isticmaale Lama Helin", "Ma jiraan diiwaanno guul", "Natiijooyinka guusha", "Faa'iido", "Natiijo", "Nooc", "Ciyaar", "Dhibco", "Taariikh", "Waqti", "Sharad", "Wadarta Guusha", "Odds", "Aqoonsiga sharadka", "Qari hadhaaga", "Muuji hadhaaga", "Dejinta portfolio", "Correct Score", "Antscore", "Guul", "Hantidaada forex halkan ayay ka muuqan doontaa.", "Fadlan mar kale gal si aad u aragto dakhliga.", "Natiijooyinka guusha halkan ayay ka muuqan doonaan.", "PnL maanta"],
  rw: ["Amafaranga ateganyijwe", "Shyiramo amafaranga", "Kuramo amafaranga", "Inyandiko", "Kunguka", "Portfolio", "Inkunga", "Ubucuruzi", "Inyungu", "Inyandiko zo kubikuza", "Inyandiko zo kubitsa", "Crypto", "Forex", "Agaciro", "Izina / Ingano", "Inyungu zirimo gupakirwa...", "Umukoresha ntiyabonetse", "Nta nyandiko z'intsinzi", "Ibisubizo by'intsinzi", "Inyungu", "Igisubizo", "Ubwoko", "Umukino", "Amanota", "Itariki", "Igihe", "Amafaranga yashyizweho", "Intsinzi yose", "Odds", "ID y'ig wager", "Hisha amafaranga", "Erekana amafaranga", "Igenamiterere rya portfolio", "Correct Score", "Antscore", "Intsinzi", "Umutungo wawe wa forex uzagaragara hano.", "Ongera winjire kugira ngo urebe inyungu.", "Ibisubizo by'intsinzi yawe bizagaragara hano.", "PnL y'uyu munsi"],
  lg: ["Ensasula Eteeberezebwa", "Teekamu Ssente", "Gyayo Ssente", "Ebiwandiiko", "Funa", "Portfolio", "Okuteekamu ssente", "Okusuubula", "Enyingiza", "Ebiwandiiko by'okuggyayo", "Ebiwandiiko by'okuteekamu", "Crypto", "Forex", "Omuwendo", "Erinnya / Omuwendo", "Enyingiza zikyapakibwa...", "Omukozesa Teyazuuliddwa", "Tewali biwandiiko bya buwanguzi", "Ebivudde mu buwanguzi", "Amagoba", "Ekivuddemu", "Ekika", "Omupiira", "Obubonero", "Olunaku", "Obudde", "Ssente eziteereddwa", "Obuwanguzi bwonna", "Odds", "ID y'okuteebereza", "Kweka ensasula", "Laga ensasula", "Enteekateeka za portfolio", "Correct Score", "Antscore", "Obuwanguzi", "Ebintu byo ebya forex bijja kulabikira wano.", "Ddamu okuyingira olabe enyingiza yo.", "Ebivudde mu buwanguzi bwo bijja kulabikira wano.", "PnL ya leero"],
  af: ["Geskatte saldo", "Deponeer", "Onttrek", "Rekords", "Verdien", "Portefeulje", "Befondsing", "Handel", "Verdienste", "Onttrekkingsrekord", "Deposito-rekord", "Kripto", "Forex", "Waarde", "Naam / Bedrag", "Verdienste laai...", "Gebruiker nie gevind nie", "Geen wenrekords", "Wenresultate", "Wins", "Resultaat", "Tipe", "Wedstryd", "Telling", "Datum", "Tyd", "Inzet", "Totale wen", "Kans", "Wed-ID", "Verberg saldo", "Wys saldo", "Portefeulje-instellings", "Korrekte telling", "Antscore", "Wen", "Jou forex-bates sal hier verskyn.", "Meld asseblief weer aan om jou verdienste te sien.", "Jou wenresultate sal hier verskyn.", "Vandag se PnL"],
};

const getLabels = (language) => {
  const values = languageLabels[language] || languageLabels.en;
  return Object.fromEntries(translationKeys.map((key, index) => [key, values[index]]));
};



export default function Assets() {

  const navigate = useNavigate();

  const [language, setLanguage] = useState(
    () => localStorage.getItem("language") || "en"
  );

  useEffect(() => {
    const syncLanguage = () => {
      setLanguage(localStorage.getItem("language") || "en");
    };

    window.addEventListener("languageChanged", syncLanguage);
    window.addEventListener("storage", syncLanguage);

    return () => {
      window.removeEventListener("languageChanged", syncLanguage);
      window.removeEventListener("storage", syncLanguage);
    };
  }, []);

  const t = getLabels(language);


  /* =========================================================
     ACTIVE TAB
  ========================================================= */

  const [tab, setTab] =
    useState("withdraw");


  /* =========================================================
     BALANCE STATE
  ========================================================= */

  const [balances, setBalances] =
    useState({});


  const [balanceLoading, setBalanceLoading] =
    useState(true);


  const [selectedCurrency, setSelectedCurrency] =
    useState(null);


  const [balanceMenuOpen, setBalanceMenuOpen] =
    useState(false);


  /* =========================================================
     BALANCE VISIBILITY
  ========================================================= */

  const [showBalance, setShowBalance] =
    useState(true);


  /* =========================================================
     EARNING STATE
  ========================================================= */

  const [earningRecords, setEarningRecords] =
    useState([]);


  const [earningLoading, setEarningLoading] =
    useState(true);


  const [earningOpenId, setEarningOpenId] =
    useState(null);


  /* =========================================================
     TRADING AND EARN TOTALS
  ========================================================= */

  const [tradingTotals, setTradingTotals] =
    useState({});

  const [earnTotals, setEarnTotals] =
    useState({});


  /* =========================================================
     USERNAME
  ========================================================= */

  const username =
    localStorage.getItem("username") || "";


  /* =========================================================
     REAL-TIME BALANCE
  ========================================================= */

  useEffect(() => {

    if (!username) {

      setBalances({});

      setBalanceLoading(false);

      return;

    }


    setBalanceLoading(true);


    /* =======================================================
       USER QUERY
    ======================================================= */

    const userQuery =
      query(
        collection(
          db,
          "users"
        ),

        where(
          "username",
          "==",
          username
        )
      );


    /* =======================================================
       FIRESTORE REAL-TIME LISTENER
    ======================================================= */

    const unsubscribe =
      onSnapshot(

        userQuery,

        (snapshot) => {

          if (
            snapshot.empty
          ) {

            setBalances({});

            setBalanceLoading(false);

            return;

          }


          const userData =
            snapshot.docs[0].data();


          const loadedBalances =
            {};


          /* ================================================
             LOAD ALL CURRENCIES
          ================================================ */

          Object.entries(
            fieldMap
          ).forEach(
            ([
              currency,
              field,
            ]) => {

              const value =
                Number(
                  userData[field] ?? 0
                );


              loadedBalances[
                currency
              ] =
                Number.isFinite(
                  value
                )
                  ? value
                  : 0;

            }
          );


          /* ================================================
             UPDATE BALANCE IMMEDIATELY
          ================================================ */

          setBalances(
            loadedBalances
          );


          setBalanceLoading(
            false
          );

        },

        (error) => {

          console.error(
            "Assets balance error:",
            error
          );


          setBalances({});

          setBalanceLoading(
            false
          );

        }

      );


    /* =======================================================
       CLEANUP
    ======================================================= */

    return () => {

      unsubscribe();

    };

  }, [username]);


  /* =========================================================
     AVAILABLE BALANCES
     ONLY BALANCES > 0
  ========================================================= */

  const availableBalances =
    Object.entries(
      balances
    )
      .filter(
        ([, value]) =>
          Number(value || 0) > 0
      )
      .map(
        ([
          currency,
          balance,
        ]) => ({

          currency,

          balance:
            Number(
              balance || 0
            ),

        })
      );


  /* =========================================================
     DEFAULT CURRENCY
  ========================================================= */

  useEffect(() => {

    if (
      availableBalances.length === 0
    ) {

      setSelectedCurrency(
        null
      );

      return;

    }


    const exists =
      availableBalances.some(
        item =>
          item.currency ===
          selectedCurrency
      );


    if (!exists) {

      setSelectedCurrency(
        availableBalances[0].currency
      );

    }

  }, [
    balances,
    selectedCurrency,
  ]);


  /* =========================================================
     MULTIPLE BALANCES
  ========================================================= */

  const hasMultipleBalances =
    availableBalances.length > 1;


  /* =========================================================
     CURRENT BALANCE
  ========================================================= */

  const getCurrentBalance = () => {

    if (
      balanceLoading
    ) {

      return {

        currency: "TZS",

        balance: 0,

      };

    }


    if (
      availableBalances.length === 0
    ) {

      return {

        currency: "TZS",

        balance: 0,

      };

    }


    const selected =
      availableBalances.find(
        item =>
          item.currency ===
          selectedCurrency
      );


    return (
      selected ||
      availableBalances[0]
    );

  };


  const currentBalance =
    getCurrentBalance();


  /* =========================================================
     FORMAT MONEY
  ========================================================= */

  const formatMoney = (
    amount
  ) => {

    const number =
      Number(
        amount ?? 0
      );


    if (
      !Number.isFinite(
        number
      )
    ) {

      return "0.00";

    }


    return number.toLocaleString(
      "en-GB",
      {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }
    );

  };


  /* =========================================================
     DISPLAY BALANCE
  ========================================================= */

  const displayBalance =
    balanceLoading

      ? "..."

      : showBalance

        ? formatMoney(
            currentBalance.balance
          )

        : "••••••";


  /* =========================================================
     BALANCE CLICK
  ========================================================= */

  const handleBalanceClick = () => {

    if (
      hasMultipleBalances
    ) {

      setBalanceMenuOpen(
        previous =>
          !previous
      );

    }

  };


  /* =========================================================
     SELECT CURRENCY
  ========================================================= */

  const handleSelectCurrency = (
    currency
  ) => {

    setSelectedCurrency(
      currency
    );

    setBalanceMenuOpen(
      false
    );

  };


  /* =========================================================
     REAL-TIME TRADING STAKE AND EARN PROFIT TOTALS
     Trading = jumla ya stake zote
     Earn = profit ya bets zilizo na result "win" pekee
  ========================================================= */

  useEffect(() => {
    if (!username) {
      setTradingTotals({});
      setEarnTotals({});
      return;
    }

    let antRecords = [];
    let correctRecords = [];

    const updateTotals = () => {
      const allBets = [...antRecords, ...correctRecords];
      const stakes = {};
      const profits = {};

      allBets.forEach((bet) => {
        const currency = String(bet.currency || "TZS").toUpperCase();
        const rawStake = bet.stake ?? bet.amount ?? bet.quantity ?? 0;
        const stake = Number(rawStake);

        if (Number.isFinite(stake)) {
          stakes[currency] = (stakes[currency] || 0) + stake;
        }

        const result = String(bet.result || "").trim().toLowerCase();
        if (result === "win") {
          const rawProfit = bet.profit ?? 0;
          const profit = Number(rawProfit);
          if (Number.isFinite(profit)) {
            profits[currency] = (profits[currency] || 0) + profit;
          }
        }
      });

      setTradingTotals(stakes);
      setEarnTotals(profits);
    };

    const antQuery = query(
      collection(db, "antscore"),
      where("username", "==", username)
    );

    const correctQuery = query(
      collection(db, "correctscore"),
      where("username", "==", username)
    );

    const unsubscribeAnt = onSnapshot(
      antQuery,
      (snapshot) => {
        antRecords = snapshot.docs.map((item) => item.data());
        updateTotals();
      },
      (error) => console.error("Trading ant score totals error:", error)
    );

    const unsubscribeCorrect = onSnapshot(
      correctQuery,
      (snapshot) => {
        correctRecords = snapshot.docs.map((item) => item.data());
        updateTotals();
      },
      (error) => console.error("Trading correct score totals error:", error)
    );

    return () => {
      unsubscribeAnt();
      unsubscribeCorrect();
    };
  }, [username]);


  /* =========================================================
     TOGGLE BALANCE
  ========================================================= */

  const toggleBalance = () => {

    setShowBalance(
      previous =>
        !previous
    );

  };


  /* =========================================================
     PORTFOLIO
  ========================================================= */

  const portfolio = [

    {
      title: t.funding,

      icon: <FaWallet />,

      amount:
        `${currentBalance.currency} ${
          showBalance
            ? formatMoney(
                currentBalance.balance
              )
            : "••••••"
        }`,
    },

    {
      title: t.trading,

      icon: <FaExchangeAlt />,

      amount:
        `${currentBalance.currency} ${
          showBalance
            ? formatMoney(
                tradingTotals[currentBalance.currency] || 0
              )
            : "••••••"
        }`,
    },

    {
      title: t.earn,

      icon: <FaCoins />,

      amount:
        `${currentBalance.currency} ${
          showBalance
            ? formatMoney(
                earnTotals[currentBalance.currency] || 0
              )
            : "••••••"
        }`,
    },

  ];


  /* =========================================================
     CRYPTO
  ========================================================= */

  const crypto = [

    {
      name: "BTC",
      amount: "0.00000000",
      value: "TZS 0.00",
      color: "#ff9800",
    },

    {
      name: "USDT",
      amount: "0.00000000",
      value: "TZS 0.00",
      color: "#00b894",
    },

    {
      name: "ETH",
      amount: "0.00000000",
      value: "TZS 0.00",
      color: "#5c6bc0",
    },

    {
      name: "BNB",
      amount: "0.00000000",
      value: "TZS 0.00",
      color: "#ffc107",
    },

    {
      name: "TRX",
      amount: "0.00000000",
      value: "TZS 0.00",
      color: "#f44336",
    },

  ];


  /* =========================================================
     BACK
  ========================================================= */

  const handleBack = () => {

    navigate(-1);

  };


  /* =========================================================
     TOP ACTIONS
  ========================================================= */

  const handleDeposit = () => {

    navigate(
      "/deposit"
    );

  };


  const handleWithdraw = () => {

    navigate(
      "/withdraw"
    );

  };


  const handleRecords = () => {

    navigate(
      "/records"
    );

  };


  const handleEarn = () => {

    setTab(
      "earning"
    );

  };


  /* =========================================================
     TAB CHANGE
  ========================================================= */

  const changeTab = (
    newTab
  ) => {

    setTab(
      newTab
    );

  };


  /* =========================================================
     EARNING TIMESTAMP
  ========================================================= */

  const getEarningTimestamp = (
    record
  ) => {

    if (
      record?.paidAt?.seconds
    ) {

      return (
        Number(
          record.paidAt.seconds
        ) * 1000
      );

    }


    if (
      record?.createdAt?.seconds
    ) {

      return (
        Number(
          record.createdAt.seconds
        ) * 1000
      );

    }


    if (
      record?.timestamp?.seconds
    ) {

      return (
        Number(
          record.timestamp.seconds
        ) * 1000
      );

    }


    if (
      record?.matchTimestamp?.seconds
    ) {

      return (
        Number(
          record.matchTimestamp.seconds
        ) * 1000
      );

    }


    if (
      typeof record?.paidAt ===
      "number"
    ) {

      return Number(
        record.paidAt
      );

    }


    if (
      typeof record?.createdAt ===
      "number"
    ) {

      return Number(
        record.createdAt
      );

    }


    return 0;

  };


  /* =========================================================
     LOAD ONLY WINNING EARNINGS
  ========================================================= */

  useEffect(() => {

    if (!username) {

      setEarningRecords([]);

      setEarningLoading(false);

      return;

    }


    setEarningLoading(true);


    let antRecords = [];

    let correctRecords = [];


    /* =======================================================
       COMBINE
    ======================================================= */

    const updateEarnings = () => {

      const combined = [

        ...antRecords,

        ...correctRecords,

      ];


      const wins =
        combined.filter(
          record => {

            const result =
              String(
                record?.result || ""
              )
                .trim()
                .toLowerCase();


            return (
              result === "win"
            );

          }
        );


      wins.sort(
        (a, b) => {

          return (
            getEarningTimestamp(
              b
            ) -
            getEarningTimestamp(
              a
            )
          );

        }
      );


      setEarningRecords(
        wins
      );


      setEarningLoading(
        false
      );

    };


    /* =======================================================
       ANTSCORE
    ======================================================= */

    const antQuery =
      query(
        collection(
          db,
          "antscore"
        ),

        where(
          "username",
          "==",
          username
        )
      );


    /* =======================================================
       CORRECT SCORE
    ======================================================= */

    const correctQuery =
      query(
        collection(
          db,
          "correctscore"
        ),

        where(
          "username",
          "==",
          username
        )
      );


    /* =======================================================
       ANTSCORE SNAPSHOT
    ======================================================= */

    const unsubscribeAnt =
      onSnapshot(

        antQuery,

        snapshot => {

          antRecords =
            snapshot.docs.map(
              item => ({

                id:
                  item.id,

                ...item.data(),

                recordSource:
                  "antscore",

              })
            );


          updateEarnings();

        },

        error => {

          console.error(
            "Antscore earning error:",
            error
          );


          antRecords = [];

          updateEarnings();

        }

      );


    /* =======================================================
       CORRECT SCORE SNAPSHOT
    ======================================================= */

    const unsubscribeCorrect =
      onSnapshot(

        correctQuery,

        snapshot => {

          correctRecords =
            snapshot.docs.map(
              item => ({

                id:
                  item.id,

                ...item.data(),

                recordSource:
                  "correctscore",

              })
            );


          updateEarnings();

        },

        error => {

          console.error(
            "Correctscore earning error:",
            error
          );


          correctRecords = [];

          updateEarnings();

        }

      );


    /* =======================================================
       CLEANUP
    ======================================================= */

    return () => {

      unsubscribeAnt();

      unsubscribeCorrect();

    };

  }, [username]);


  /* =========================================================
     FORMAT DATE
  ========================================================= */

  const formatEarningDate = (
    record
  ) => {

    const timestamp =
      getEarningTimestamp(
        record
      );


    if (!timestamp) {

      return "--/--/----";

    }


    return new Date(
      timestamp
    ).toLocaleDateString(
      "en-GB",
      {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      }
    );

  };


  /* =========================================================
     FORMAT TIME
  ========================================================= */

  const formatEarningTime = (
    record
  ) => {

    const timestamp =
      getEarningTimestamp(
        record
      );


    if (!timestamp) {

      return "--:--";

    }


    return new Date(
      timestamp
    ).toLocaleTimeString(
      "en-GB",
      {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      }
    );

  };


  /* =========================================================
     EARNING TYPE
  ========================================================= */

  const getEarningType = (
    record
  ) => {

    if (
      record?.type ===
      "correctscore"
    ) {

      return t.correctScore;

    }


    if (
      record?.recordSource ===
      "correctscore"
    ) {

      return t.correctScore;

    }


    if (
      record?.mode ===
      "correct"
    ) {

      return t.correctScore;

    }


    return t.antscore;

  };


  /* =========================================================
     WIN AMOUNT
  ========================================================= */

  const getWinAmount = (
    record
  ) => {

    if (
      record?.totalWin !==
      undefined &&
      record?.totalWin !==
      null
    ) {

      return Number(
        record.totalWin
      );

    }


    const stake =
      Number(
        record?.stake ??
        record?.amount ??
        0
      );


    const profit =
      Number(
        record?.profit ||
        0
      );


    return (
      stake +
      profit
    );

  };


  /* =========================================================
     PROFIT
  ========================================================= */

  const getProfit = (
    record
  ) => {

    return Number(
      record?.profit || 0
    );

  };


  /* =========================================================
     TOTAL EARNINGS
  ========================================================= */

  const totalEarnings =
    earningRecords.reduce(
      (
        total,
        record
      ) => {

        return (
          total +
          getProfit(record)
        );

      },
      0
    );


  /* =========================================================
     TOGGLE EARNING
  ========================================================= */

  const toggleEarningDetails = (
    id
  ) => {

    setEarningOpenId(
      current =>
        current === id
          ? null
          : id
    );

  };


  /* =========================================================
     CRYPTO CONTENT
  ========================================================= */

  const CryptoContent = () => {

    return (

      <div className="crypto-content">


        <div className="crypto-table-head">

          <span>
            {t.nameAmount}
          </span>

          <span>
            {t.value}
          </span>

        </div>


        <div className="crypto-list">

          {crypto.map(
            (coin, index) => (

              <div
                key={index}
                className="crypto-row"
              >

                <div className="crypto-left">

                  <div
                    className="coin-logo"
                    style={{
                      background:
                        coin.color,
                    }}
                  >

                    {coin.name.substring(
                      0,
                      1
                    )}

                  </div>


                  <div>

                    <h3>
                      {coin.name}
                    </h3>

                    <p>
                      {coin.amount}
                    </p>

                  </div>

                </div>


                <div className="crypto-right">

                  <h3>
                    {coin.value}
                  </h3>

                  <p className="profit">
                    0.00%
                  </p>

                </div>

              </div>

            )
          )}

        </div>

      </div>

    );

  };


  /* =========================================================
     FOREX CONTENT
  ========================================================= */

  const ForexContent = () => {

    return (

      <div className="record-inline-box">

        <div className="record-inline-icon">

          <FaExchangeAlt />

        </div>


        <div className="record-inline-content">

          <strong>
            {t.forex}
          </strong>

          <span>
            {t.yourForexAssets}
          </span>

        </div>

      </div>

    );

  };


  /* =========================================================
     EARNING CONTENT
  ========================================================= */

  const EarningContent = () => {

    if (earningLoading) {

      return (

        <div className="earning-record">

          <div className="earning-loading">

            {t.loadingEarnings}

          </div>

        </div>

      );

    }


    if (!username) {

      return (

        <div className="earning-record">

          <div className="earning-empty">

            <div className="earning-empty-icon">

              <FaTrophy />

            </div>


            <h3>
              {t.userNotFound}
            </h3>


            <p>
              {t.pleaseLogin}
            </p>

          </div>

        </div>

      );

    }


    if (
      earningRecords.length === 0
    ) {

      return (

        <div className="earning-record">

          <div className="earning-empty">

            <div className="earning-empty-icon">

              <FaTrophy />

            </div>


            <h3>
              {t.noWinningRecords}
            </h3>


            <p>
              {t.yourWinningResults}
            </p>

          </div>

        </div>

      );

    }


    return (

      <div className="earning-record">


        {/* ===================================================
            EARNING HEADER
        =================================================== */}

        <div className="earning-header">

          <div>

            <h2>
              {t.earning}
            </h2>

            <p>
              {t.winningResults}
            </p>

          </div>


          <div className="earning-total">

            <span>
              {t.profit}
            </span>


            <strong>

              +
              {formatMoney(
                totalEarnings
              )}

            </strong>

          </div>


          <div className="earning-count">

            {earningRecords.length}

          </div>

        </div>


        {/* ===================================================
            EARNING LIST
        =================================================== */}

        <div className="earning-list">

          {earningRecords.map(
            record => {

              const uniqueId =
              `${record.recordSource}-${record.id}`;


              const isOpen =
                earningOpenId ===
                uniqueId;


              const winAmount =
                getWinAmount(
                  record
                );


              const profit =
                getProfit(
                  record
                );


              return (

                <div
                  key={uniqueId}
                  className={
                    `earning-item ${
                      isOpen
                        ? "is-open"
                        : ""
                    }`
                  }
                >

                  {/* MAIN ROW */}

                  <button
                    type="button"
                    className="earning-main-row"
                    onClick={() =>
                      toggleEarningDetails(
                        uniqueId
                      )
                    }
                  >

                    <div className="earning-main-left">

                      <div className="earning-type">

                        {getEarningType(
                          record
                        )}

                      </div>


                      <div className="earning-date">

                        <span>

                          {formatEarningDate(
                            record
                          )}

                        </span>


                        <span className="earning-time">

                          {formatEarningTime(
                            record
                          )}

                        </span>

                      </div>

                    </div>


                    <div className="earning-main-amount">

                      +
                      {formatMoney(
                        winAmount
                      )}{" "}

                      {record.currency ||
                        "TZS"}

                    </div>


                    <div className="earning-main-status">

                      {t.win}

                    </div>


                    <div className="earning-arrow">

                      {isOpen ? (
                        <FaChevronUp />
                      ) : (
                        <FaChevronDown />
                      )}

                    </div>

                  </button>


                  {/* DETAILS */}

                  {isOpen && (

                    <div className="earning-details-panel">


                      <div className="earning-detail-row">

                        <span>
                          {t.result}
                        </span>

                        <strong className="earning-win">
                          {t.win}
                        </strong>

                      </div>


                      <div className="earning-detail-row">

                        <span>
                          {t.type}
                        </span>

                        <strong>

                          {getEarningType(
                            record
                          )}

                        </strong>

                      </div>


                      <div className="earning-detail-row">

                        <span>
                          {t.match}
                        </span>

                        <strong>

                          {record.teamA ||
                            "Team A"}

                          {" vs "}

                          {record.teamB ||
                            "Team B"}

                        </strong>

                      </div>


                      <div className="earning-detail-row">

                        <span>
                          {t.score}
                        </span>

                        <strong>

                          {record.score ||
                            "-"}

                        </strong>

                      </div>


                      <div className="earning-detail-row">

                        <span>
                          {t.date}
                        </span>

                        <strong>

                          {formatEarningDate(
                            record
                          )}

                        </strong>

                      </div>


                      <div className="earning-detail-row">

                        <span>
                          {t.time}
                        </span>

                        <strong>

                          {formatEarningTime(
                            record
                          )}

                        </strong>

                      </div>


                      <div className="earning-detail-row">

                        <span>
                          {t.stake}
                        </span>

                        <strong>

                          {formatMoney(
                            record.stake ??
                            record.amount
                          )}{" "}

                          {record.currency ||
                            "TZS"}

                        </strong>

                      </div>


                      <div className="earning-detail-row">

                        <span>
                          {t.profit}
                        </span>

                        <strong className="earning-profit">

                          +
                          {formatMoney(
                            profit
                          )}{" "}

                          {record.currency ||
                            "TZS"}

                        </strong>

                      </div>


                      <div className="earning-detail-row">

                        <span>
                          {t.totalWin}
                        </span>

                        <strong className="earning-win">

                          +
                          {formatMoney(
                            winAmount
                          )}{" "}

                          {record.currency ||
                            "TZS"}

                        </strong>

                      </div>


                      <div className="earning-detail-row">

                        <span>
                          {t.odds}
                        </span>

                        <strong>

                          {record.odds ??
                            "-"}

                          %

                        </strong>

                      </div>


                      <div className="earning-detail-row">

                        <span>
                          {t.betId}
                        </span>

                        <strong className="earning-bet-id">

                          {record.betId ||
                            "-"}

                        </strong>

                      </div>


                    </div>

                  )}

                </div>

              );

            }
          )}

        </div>

      </div>

    );

  };


  /* =========================================================
     RETURN
  ========================================================= */

  return (

    <div className="assets-page">


      {/* =====================================================
          HEADER
      ===================================================== */}

      <div className="assets-header">


        {/* BACK */}

        <button
          type="button"
          className="asset-back-btn"
          onClick={handleBack}
          aria-label="Go back"
        >

          <FaArrowLeft />

        </button>


        {/* BALANCE EYE */}

        <button
          type="button"
          className="asset-eye-btn"
          onClick={toggleBalance}
          aria-label={
            showBalance
              ? t.hideBalance
              : t.showBalance
          }
        >

          {showBalance ? (

            <FaEye />

          ) : (

            <FaEyeSlash />

          )}

        </button>


      </div>


      {/* =====================================================
          BALANCE
      ===================================================== */}

      <div className="balance-box">


        <div className="balance-title">

          {t.estimatedBalance}

        </div>


        {/* ===================================================
            REAL-TIME BALANCE BUTTON
        =================================================== */}

        <button
          type="button"
          className="assets-balance-button"
          onClick={handleBalanceClick}
        >


          <span className="assets-balance-currency">

            {currentBalance.currency}

          </span>


          <span className="assets-balance-amount">

            {displayBalance}

          </span>


          {hasMultipleBalances && (

            <FaChevronDown
              className={
                balanceMenuOpen
                  ? "assets-balance-arrow rotate"
                  : "assets-balance-arrow"
              }
            />

          )}


        </button>


        {/* ===================================================
            BALANCE MENU
        =================================================== */}

        {balanceMenuOpen &&
          hasMultipleBalances && (

          <div className="assets-balance-menu">


            {availableBalances.map(
              item => {

                const active =
                  item.currency ===
                  selectedCurrency;


                return (

                  <button
                    type="button"
                    key={
                      item.currency
                    }
                    className={
                      active
                        ? "assets-balance-option active"
                        : "assets-balance-option"
                    }
                    onClick={() =>
                      handleSelectCurrency(
                        item.currency
                      )
                    }
                  >

                    <span>

                      {item.currency}

                    </span>


                    <strong>

                      {showBalance
                        ? formatMoney(
                            item.balance
                          )
                        : "••••••"}

                    </strong>

                  </button>

                );

              }
            )}


          </div>

        )}


        {/* ===================================================
            TODAY PNL
        =================================================== */}

        <div className="today-pnl">

          {t.todayPnl}{" "}

          {currentBalance.currency}{" "}

          0.00 (0.00%)

        </div>


      </div>


      {/* =====================================================
          ACTION BUTTONS
      ===================================================== */}

      <div className="asset-actions">


        {/* DEPOSIT */}

        <button
          type="button"
          className="asset-action"
          onClick={handleDeposit}
        >

          <span className="circle-btn">

            <FaDownload />

          </span>


          <span>
            {t.deposit}
          </span>

        </button>


        {/* WITHDRAW */}

        <button
          type="button"
          className="asset-action"
          onClick={handleWithdraw}
        >

          <span className="circle-btn">

            <FaUpload />

          </span>


          <span>
            {t.withdraw}
          </span>

        </button>


        {/* RECORDS */}

        <button
          type="button"
          className="asset-action"
          onClick={handleRecords}
        >

          <span className="circle-btn">

            <FaExchangeAlt />

          </span>


          <span>
            {t.records}
          </span>

        </button>


        {/* EARN */}

        <button
          type="button"
          className="asset-action"
          onClick={handleEarn}
        >

          <span className="circle-btn">

            <FaCoins />

          </span>


          <span>
            {t.earn}
          </span>

        </button>


      </div>


      {/* =====================================================
          PORTFOLIO
      ===================================================== */}

      <div className="portfolio-title">


        <h2>
          {t.portfolio}
        </h2>


        <button
          type="button"
          className="portfolio-filter-btn"
          aria-label={t.portfolioSettings}
        >

          <FaSlidersH />

        </button>


      </div>


      <div className="portfolio-scroll">


        {portfolio.map(
          (item, index) => (

            <button
              type="button"
              key={index}
              className="portfolio-card"
            >


              <div className="portfolio-icon">

                {item.icon}

              </div>


              <h3>

                {item.title}

              </h3>


              <h4>

                {item.amount}

              </h4>


            </button>

          )
        )}


      </div>


      {/* =====================================================
          TABS
      ===================================================== */}

      <div className="asset-tabs">


        {/* WITHDRAW RECORD */}

        <button
          type="button"
          className={
            tab === "withdraw"
              ? "active"
              : ""
          }
          onClick={() =>
            changeTab(
              "withdraw"
            )
          }
        >

          {t.withdrawRecord}

        </button>


        {/* DEPOSIT RECORD */}

        <button
          type="button"
          className={
            tab === "deposit"
              ? "active"
              : ""
          }
          onClick={() =>
            changeTab(
              "deposit"
            )
          }
        >

          {t.depositRecord}

        </button>


        {/* CRYPTO */}

        <button
          type="button"
          className={
            tab === "crypto"
              ? "active"
              : ""
          }
          onClick={() =>
            changeTab(
              "crypto"
            )
          }
        >

          {t.crypto}

        </button>


        {/* FOREX */}

        <button
          type="button"
          className={
            tab === "forex"
              ? "active"
              : ""
          }
          onClick={() =>
            changeTab(
              "forex"
            )
          }
        >

          {t.forex}

        </button>


        {/* EARNING */}

        <button
          type="button"
          className={
            tab === "earning"
              ? "active"
              : ""
          }
          onClick={() =>
            changeTab(
              "earning"
            )
          }
        >

          {t.earning}

        </button>


      </div>


      {/* =====================================================
          CONTENT
      ===================================================== */}


      {/* =====================================================
          IMPORTANT:
          HAPA TUNATUMIA WITHDRAWRECORD YAKO HALISI.
          MUUNDO WAKE HAUBADILISHWI.
      ===================================================== */}

      {tab === "withdraw" && (

        <WithdrawRecord />

      )}


      {/* =====================================================
          DEPOSIT RECORD
      ===================================================== */}

      {tab === "deposit" && (

        <DepositRecord />

      )}


      {/* =====================================================
          CRYPTO
      ===================================================== */}

      {tab === "crypto" && (

        <CryptoContent />

      )}


      {/* =====================================================
          FOREX
      ===================================================== */}

      {tab === "forex" && (

        <ForexContent />

      )}


      {/* =====================================================
          EARNING
      ===================================================== */}

      {tab === "earning" && (

        <EarningContent />

      )}


      {/* =====================================================
          BOTTOM SPACE
      ===================================================== */}

      <div
        style={{
          height: "70px",
        }}
      />


    </div>

  );

}
